import {
    CREATE_RECEIVE_SETS,
    CREATE_RECEIVE_SETS_SUCCESS,
    CREATE_RECEIVE_SETS_FAILURE,
    CATEGORY_SELECTED,
    RESET_CREATE_RECEIVE_SETS,
    CHECK_IS_OUTSIDE_TERRITORY,
    SHOW_ERROR_MESSAGE_POPUP,
} from '../actions';

const initialState = {
    createReceiveSets: [],
    receiveSetsLoading: false,
    categoryId: 1,
    appliedCategory: {},
    isSubmittedPage: false,
    showErrorPopupMessage: false,
};

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const createReceiveSetsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_RECEIVE_SETS:
        case CHECK_IS_OUTSIDE_TERRITORY:
            return {
                ...state,
                receiveSetsLoading: true,
            };
        case SHOW_ERROR_MESSAGE_POPUP:
            return {
                ...state,
                showErrorPopupMessage: action.payload,
                receiveSetsLoading: false,
            };
        // case CHECK_IS_OUTSIDE_TERRITORY_SUCCESS:
        //     return{
        //         ...state,
        //         receiveSetsLoading:false,
        //     }
        case RESET_CREATE_RECEIVE_SETS:
            return {
                ...state,
                createReceiveSets: [],
                receiveSetsLoading: false,
            };
        case CREATE_RECEIVE_SETS_SUCCESS:
            return {
                ...state,
                createReceiveSets: action.data,
                receiveSetsLoading: false,
            };
        case CREATE_RECEIVE_SETS_FAILURE:
            return {
                ...state,
                createReceiveSets: action.payload ? action.payload : [],
                receiveSetsLoading: false,
            };
        case CATEGORY_SELECTED:
            return {
                ...state,
                categoryId: action.payload.id,
                appliedCategory: { ...action.payload },
            };
        case 'STORE_IS_SUBMIT_PAGE':
            return {
                ...state,
                isSubmittedPage: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'createReceiveSetsReducer',
        storage: storage,
        //transforms: [SetTransform],
    },
    createReceiveSetsReducer
);
